import React from "react";
import {
  Section,
  ContactContainer,
  ContactTitle,
  ContactDescription,
  PhoneContainer,
  PhoneNumber,
  StyledContetntWrapper,
} from "./Contact.styled";
import { Container } from "react-bootstrap";

const Contact = ({ t }) => {
  const formatPhoneForHref = (phone) => phone.replace(/\s+/g, "");
  return (
    <Section id="contact">
      <Container>
        <ContactContainer>
          <StyledContetntWrapper>
            <ContactDescription>{t("logo.name")}</ContactDescription>
            <ContactTitle>{t("logo.title")}</ContactTitle>
          </StyledContetntWrapper>

          <PhoneContainer>
            <PhoneNumber href={`tel:${formatPhoneForHref(t("contact.phone"))}`}>
              {t("contact.phone")}
            </PhoneNumber>
          </PhoneContainer>
        </ContactContainer>
      </Container>
    </Section>
  );
};

export default Contact;
